// import VisibilityIcon from "@mui/icons-material/Visibility";
// import {
//   Box,
//   Button,
//   IconButton,
//   Tooltip,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import jsPDF from "jspdf";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Header from "../../components/Header";
// import { tokens } from "../../theme";

// const PaymentLogs = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [data, setData] = useState([]);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://backend.jcgn.org/payment/payment-history?userId="
//         );
//         if (response.data.status) {
//           setData(response.data.result);
//         }
//       } catch (error) {
//         console.error("Error fetching payment logs data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const columns = [
//     { field: "id", headerName: "ID", flex: 1 },
//     { field: "userId", headerName: "User ID", flex: 0.5 },
//     {
//       field: "description",
//       headerName: "Description",
//       flex: 1,
//       // cellClassName: "name-column--cell",
//       // renderCell: (params) => {
//       //   const handleOpen = (event) => setAnchorEl(event.currentTarget);
//       //   const handleClose = () => setAnchorEl(null);

//       //   return (
//       //     <Box display="flex" alignItems="center" gap={1}>
//       //       {params.value === "Donation" ? (
//       //         <>
//       //           <Typography
//       //             sx={{
//       //               fontSize: "14px",
//       //               color: "greenAccent[300]",
//       //               cursor: "pointer",
//       //             }}
//       //             onClick={handleOpen}
//       //           >
//       //             {params.value}
//       //           </Typography>
//       //           <ExpandMoreIcon
//       //             sx={{
//       //               cursor: "pointer",
//       //               color: "greenAccent[300]",
//       //             }}
//       //             onClick={handleOpen}
//       //           />
//       //           <Menu
//       //             anchorEl={anchorEl}
//       //             open={Boolean(anchorEl)}
//       //             onClose={handleClose}
//       //           >
//       //             <MenuItem>
//       //               Donation Type:{" "}
//       //               <b>
//       //                 {params.row.metadata?.donationType || "Not Available"}
//       //               </b>
//       //             </MenuItem>
//       //           </Menu>
//       //         </>
//       //       ) : (
//       //         <Typography>{params.value}</Typography>
//       //       )}
//       //     </Box>
//       //   );
//       // },
//     },
//     {
//       field: "donationType",
//       headerName: "Donation Type",
//       flex: 1,
//       renderCell: (params) => (
//         <Typography>
//           {params.row.metadata?.donationType || "Not Available"}
//         </Typography>
//       ),
//     },
//     {
//       field: "amount",
//       headerName: "Amount",
//       flex: 0.5,
//     },
//     {
//       field: "status",
//       headerName: "Status",
//       flex: 0.5,
//     },
//     {
//       field: "date",
//       headerName: "Date",
//       flex: 1,
//       type: "date",
//       valueGetter: (params) => new Date(params.value),
//     },
//     {
//       field: "Actions",
//       headerName: "Actions",
//       flex: 0.5,
//       renderCell: (params) => (
//         <Box>
//           <Tooltip title="View Details">
//             <IconButton onClick={() => handleViewClick(params.row.id)}>
//               <VisibilityIcon />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   // const handleViewClick = (userId) => {
//   //   navigate(`/paymentlogs/view/${userId}`);
//   // };

//   const handleViewClick = (id) => {
//     navigate(`/paymentlogsbyID/view/${id}`);
//   };

//   const exportToPdf = () => {
//     const doc = new jsPDF();
//     doc.autoTable({
//       head: [["ID", "User ID", "Description", "Amount", "Status", "Date"]],
//       body: data.map(({ id, userId, description, amount, status, date }) => [
//         id,
//         userId,
//         description,
//         amount,
//         status,
//         new Date(date).toLocaleDateString(),
//       ]),
//     });
//     doc.save("payment_logs.pdf");
//   };

//   const getRowClassName = () => {
//     return "row-divider";
//   };

//   return (
//     <Box m="20px">
//       <Header title="Payment Logs Management" subtitle="" />
//       <Box
//         m="0 0 0 0"
//         height="60vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//             fontSize: "14px",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .name-column--cell": {
//             color: colors.greenAccent[300],
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.greenAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.greenAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//           "& .row-divider": {
//             borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
//           },
//         }}
//       >
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Button
//             variant="contained"
//             onClick={exportToPdf}
//             sx={{
//               backgroundColor: "#4caf50",
//               color: "white",
//               fontSize: "10px",
//               "&:hover": {
//                 backgroundColor: "#388e3c",
//               },
//             }}
//           >
//             Export to PDF
//           </Button>
//         </Box>
//         <DataGrid
//           rows={data}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//           getRowClassName={getRowClassName}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default PaymentLogs;


import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  InputAdornment,
  Chip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { authFetch, getAuthHeaders } from "../../Utils/apiClient";

const PaymentLogs = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedAllUsers, setSelectedAllUsers] = useState(true); // Default to true
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [userDetailsMap, setUserDetailsMap] = useState({}); // Store user details by ID
  const navigate = useNavigate();

  // Load all payment logs (single API call)
  useEffect(() => {
    const init = async () => {
      setLoadingUsers(true);
      try {
        const usersResponse = await authFetch("/user/allusers");
        const usersJson = await usersResponse.json();
        if (usersJson.status) {
          const validUsers = usersJson.data.filter(
            (user) => user && user.id != null
          );
          setUsers(validUsers);
          setFilteredUsers(validUsers);
        }
        await fetchAllPaymentHistory();
      } catch (error) {
        console.error("Error loading payment logs:", error);
      } finally {
        setLoadingUsers(false);
      }
    };
    init();
  }, []);

  // Filter users based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = users.filter(user =>
        getUserDisplayName(user).toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        getUserRole(user).toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  }, [searchTerm, users]);

  // Fetch payment history when user is selected (only for specific user)
  useEffect(() => {
    if (!selectedAllUsers && selectedUserId) {
      fetchPaymentHistory(selectedUserId);
    }
  }, [selectedUserId, selectedAllUsers]);

  // Fetch user details by ID
  const fetchUserDetails = async (userId) => {
    try {
      const response = await axios.get(
        `https://backend.jcgn.org/user/getUserById/${userId}`,
        { headers: getAuthHeaders() }
      );
      if (response.data.status && response.data.result) {
        return response.data.result;
      }
    } catch (error) {
      console.error(`Error fetching user details for ID ${userId}:`, error);
    }
    return null;
  };

  const fetchPaymentHistory = async (userId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://backend.jcgn.org/payment/payment-history?userId=${userId}`
      );
      if (response.data.status && response.data.result) {
        const paymentData = response.data.result.map((item, index) => ({
          ...item,
          id: item.id || `payment-${userId}-${index}`,
        }));
        setData(paymentData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching payment logs data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const mapLogRow = (item, index) => ({
    id: item.id || `payment-${index}`,
    userId: item.userId,
    userName: item.User?.profileName,
    description: item.description || item.paidFor || "Payment",
    donationType: item.paidFor === "donation" ? item.description : undefined,
    amount: item.price,
    status: "succeeded",
    date: item.createdAt,
    paymentId: item.paymentIntent,
    metadata: { donationType: item.description },
  });

  const fetchAllPaymentHistory = async () => {
    setLoading(true);
    try {
      const response = await authFetch("/paymentlog/getAllPaymentLogs");
      const json = await response.json();
      if (json.success && json.result) {
        const rows = json.result.map(mapLogRow);
        setData(rows);
        const userMap = {};
        json.result.forEach((item) => {
          if (item.User && item.userId) {
            userMap[item.userId] = item.User;
          }
        });
        setUserDetailsMap((prev) => ({ ...prev, ...userMap }));
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching payment logs:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleUserChange = (event) => {
    const value = event.target.value;
    if (value === "all") {
      setSelectedAllUsers(true);
      setSelectedUserId("");
      // Fetch all payment history when switching back to "All Users"
      fetchAllPaymentHistory();
    } else {
      setSelectedAllUsers(false);
      setSelectedUserId(value);
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const clearFilters = () => {
    setSelectedUserId("");
    setSelectedAllUsers(true); // Default back to "All Users"
    setSearchTerm("");
    // Fetch all payment history when clearing filters
    fetchAllPaymentHistory();
  };

  // Safe color getter function
  const getStatusColor = (status) => {
    if (!colors || !colors.greenAccent || !colors.yellowAccent || !colors.redAccent || !colors.grey) {
      // Fallback colors if theme tokens are not properly defined
      switch (status) {
        case "succeeded":
        case "completed":
          return "#4caf50"; // green
        case "pending":
        case "requires_payment_method":
          return "#ff9800"; // orange
        case "failed":
        case "canceled":
          return "#f44336"; // red
        default:
          return "#9e9e9e"; // grey
      }
    }
    
    switch (status) {
      case "succeeded":
      case "completed":
        return colors.greenAccent[500] || "#4caf50";
      case "pending":
      case "requires_payment_method":
        return colors.yellowAccent[500] || "#ff9800";
      case "failed":
      case "canceled":
        return colors.redAccent[500] || "#f44336";
      default:
        return colors.grey[500] || "#9e9e9e";
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { 
      field: "userId", 
      headerName: "User ID", 
      flex: 0.5,
      renderCell: (params) => (
        <Typography>
          {params.value || "N/A"}
        </Typography>
      ),
    },
    {
      field: "userName",
      headerName: "User Name",
      flex: 1,
      renderCell: (params) => {
        const userId = params.row.userId;
        const user = userDetailsMap[userId] || users.find(u => u.id === parseInt(userId));
        return (
          <Typography>
            {getUserDisplayName(user)}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      renderCell: (params) => (
        <Typography>
          {params.value || "No description"}
        </Typography>
      ),
    },
    {
      field: "donationType",
      headerName: "Donation Type",
      flex: 1,
      renderCell: (params) => (
        <Typography>
          {params.row.metadata?.donationType || "Not Available"}
        </Typography>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.5,
      renderCell: (params) => (
        <Typography fontWeight="bold">
          ${params.value ? parseFloat(params.value).toFixed(2) : "0.00"}
        </Typography>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      renderCell: (params) => {
        const status = params.value || "unknown";
        const backgroundColor = getStatusColor(status);
        
        return (
          <Chip
            label={status}
            size="small"
            sx={{
              backgroundColor: backgroundColor,
              color: "white",
              fontWeight: "bold",
              textTransform: "capitalize",
              minWidth: "80px",
            }}
          />
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      type: "date",
      valueGetter: (params) => params.value ? new Date(params.value) : null,
      renderCell: (params) => (
        <Typography>
          {params.value ? new Date(params.value).toLocaleDateString() : "N/A"}
        </Typography>
      ),
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View Details">
            <IconButton onClick={() => handleViewClick(params.row.id)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const handleViewClick = (id) => {
    navigate(`/paymentlogsbyID/view/${id}`);
  };

  const exportToPdf = () => {
    if (data.length === 0) return;
    
    const doc = new jsPDF();
    
    // Add title based on selection
    let title = "Payment History";
    if (selectedAllUsers) {
      title = "All Users Payment History";
    } else if (selectedUserId) {
      const selectedUser = userDetailsMap[selectedUserId] || users.find(user => user.id === parseInt(selectedUserId));
      const userName = selectedUser ? getUserDisplayName(selectedUser) : "Unknown User";
      title = `Payment History - ${userName}`;
    }
    
    doc.setFontSize(16);
    doc.text(title, 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);
    doc.text(`Total Records: ${data.length}`, 14, 29);
    
    // Add table
    doc.autoTable({
      startY: 35,
      head: [["ID", "User ID", "User Name", "Description", "Amount", "Status", "Date"]],
      body: data.map((item) => {
        const user = userDetailsMap[item.userId] || users.find(u => u.id === parseInt(item.userId));
        return [
          item.id || "N/A",
          item.userId || "N/A",
          getUserDisplayName(user),
          item.description || "No description",
          `$${item.amount ? parseFloat(item.amount).toFixed(2) : "0.00"}`,
          item.status || "unknown",
          item.date ? new Date(item.date).toLocaleDateString() : "N/A",
        ];
      }),
      styles: { fontSize: 7 },
      headStyles: { fillColor: [76, 175, 80] },
    });
    
    const fileName = selectedAllUsers ? "all_users_payment_history" : 
                   `payment_history_${getUserDisplayName(userDetailsMap[selectedUserId] || users.find(user => user.id === parseInt(selectedUserId))).replace(/\s+/g, '_')}`;
    doc.save(`${fileName}.pdf`);
  };

  const getRowClassName = () => {
    return "row-divider";
  };

  // Safe user display name function
  const getUserDisplayName = (user) => {
    if (!user) return "Unknown User";
    return user.profileName || user.email || `User ${user.id}`;
  };

  // Safe user role function
  const getUserRole = (user) => {
    if (!user || !user.Role) return "No Role";
    return user.Role.role || "No Role";
  };

  return (
    <Box m="20px">
      <Header title="Payment Logs Management" subtitle="View payment history by user" />
      
      {/* Search and Filter Section */}
      <Box display="flex" gap={2} alignItems="center" mb={2} flexWrap="wrap">
        {/* Search Box */}
        <TextField
          placeholder="Search users by name, email, or role..."
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{
            minWidth: 300,
            flex: 1,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* User Selection Dropdown */}
        <FormControl sx={{ minWidth: 250 }}>
          <InputLabel id="user-select-label">Select User</InputLabel>
          <Select
            labelId="user-select-label"
            value={selectedAllUsers ? "all" : selectedUserId}
            label="Select User"
            onChange={handleUserChange}
            disabled={loadingUsers}
          >
            <MenuItem value="all">
              <Typography fontWeight="bold">
                👥 All Users
              </Typography>
            </MenuItem>
            <MenuItem value="">
              <em>Select a specific user</em>
            </MenuItem>
            {filteredUsers.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {getUserDisplayName(user)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {user.email} • {getUserRole(user)}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Clear Filters Button */}
        <Button
          variant="outlined"
          onClick={clearFilters}
          disabled={loadingUsers}
          sx={{
            borderColor: theme.palette.mode === 'dark' ? '#555' : '#757575',
            color: theme.palette.mode === 'dark' ? '#fff' : '#424242',
            '&:hover': {
              borderColor: theme.palette.mode === 'dark' ? '#777' : '#616161',
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
            },
            minWidth: '100px',
          }}
        >
          Clear
        </Button>
      </Box>

      {/* Selection Info */}
      {(selectedUserId || selectedAllUsers) && (
        <Box mb={2}>
          <Chip
            label={
              selectedAllUsers 
                ? `Viewing all users payment history • ${data.length} records`
                : `Viewing payment history for ${getUserDisplayName(userDetailsMap[selectedUserId] || users.find(user => user.id === parseInt(selectedUserId)))} • ${data.length} records`
            }
            color="primary"
            variant="outlined"
          />
        </Box>
      )}

      <Box
        m="0 0 0 0"
        height="60vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            fontSize: "14px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent ? colors.greenAccent[300] : "#81c784",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.greenAccent ? colors.greenAccent[700] : "#388e3c",
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary ? colors.primary[400] : "#f5f5f5",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.greenAccent ? colors.greenAccent[700] : "#388e3c",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent ? colors.greenAccent[200] : "#a5d6a7"} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey ? colors.grey[100] : "#f5f5f5"} !important`,
          },
          "& .row-divider": {
            borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
          },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Button
            variant="contained"
            onClick={exportToPdf}
            disabled={data.length === 0 || loading}
            sx={{
              backgroundColor: data.length === 0 || loading ? "#bdbdbd" : "#4caf50",
              color: "white",
              "&:hover": {
                backgroundColor: data.length === 0 || loading ? "#bdbdbd" : "#388e3c",
              },
            }}
          >
            Export to PDF ({data.length})
          </Button>
        </Box>
        
        {loadingUsers || loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <Typography>Loading payment history...</Typography>
          </Box>
        ) : (
          <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            getRowClassName={getRowClassName}
            loading={loading}
            autoHeight={data.length === 0}
            slots={{
              noRowsOverlay: () => (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <Typography>
                    {selectedUserId || selectedAllUsers 
                      ? "No payment history found" 
                      : "Please select a user or 'All Users' to view payment history"
                    }
                  </Typography>
                </Box>
              ),
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default PaymentLogs;